import { CircleParking } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { StepCardRow } from '../stay/StepCardRow';
import type { ArrivalStep } from '../useGuestSession';

/** Sprungziel der Ausweichmöglichkeiten — aus den Fenstern „Buchen“ und „Parksituation“. */
export const PARKING_ALTERNATIVES_ID = 'parken-alternativen';

interface Props {
  steps: ArrivalStep[];
  /** Guest-Bearer-Token für die auth-geschützten Bild-URLs. */
  token: string | undefined;
}

/**
 * Wo der Gast sonst parken kann — als Karten wie die Anfahrt, der ganze Eintrag mit allen Fotos
 * im Fenster. Steht **unter** dem eigenen Platz und dem Plan: die Frage kommt genau dort auf, wenn
 * nichts mehr frei ist. Auch in Häusern ohne Stellplätze — dafür sind die Einträge da.
 */
export function ParkingAlternativesBlock({ steps, token }: Props) {
  const { t } = useTranslation();
  return (
    <StepCardRow
      id={PARKING_ALTERNATIVES_ID}
      steps={steps}
      token={token}
      numbered={false}
      icon={CircleParking}
      labelledBy="parking-alternatives-title"
      header={
        <div className="min-w-0">
          <h3
            id="parking-alternatives-title"
            className="font-display text-fg text-lg font-semibold"
          >
            {t('parking.alternativesTitle')}
          </h3>
          <p className="text-fg-dim text-sm">{t('parking.alternativesSubtitle')}</p>
        </div>
      }
    />
  );
}

/**
 * Aus einem Fenster zu den Ausweichmöglichkeiten: erst schließt das Fenster, dann springt die
 * Seite hin und der Fokus folgt — sonst holte die Rückgabe des Fokus an den Auslöser die Seite
 * wieder nach oben.
 */
export function scrollToParkingAlternatives() {
  window.setTimeout(() => {
    // Der Sprung kommt verzögert; bis dahin kann die Seite (oder im Test die Umgebung) weg sein.
    if (typeof document === 'undefined') return;
    const target = document.getElementById(PARKING_ALTERNATIVES_ID);
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target?.focus({ preventScroll: true });
  }, 60);
}
